// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper_bf7a7"};